import { ContainerComponent, wrap } from 'AppReact';
import Controller from './controller';
import { DropdownBodyWrapper } from './wrappers';
import { FitRelativeWrapper, Ml2, FlexCenterJustifyCenterWrapper } from 'wrappers';
import { SelectorButton } from './atoms';
import React from 'react';
import internalState from './internalState';
import wrapTooltip from 'wrappers/tooltip';
import { CategoryDropdown } from './containers';
import { ClickableIcon } from 'atoms';
import { ChevronDownSvg, ChevronUpSvg } from 'components/icons';
import { DropdownSearchInput } from 'molecules';
import { filterCategories } from './helpers';

const containerRef = React.createRef();

export const definition = {
  name: 'ParentCategoryDropdown',
  controller: Controller,
  initialProps: ({ categories, selectedCategoryId, selectedParentId, isOpen }) => ({ isOpen, categories, selectedCategoryId, selectedParentId, containerRef }),
  props: internalState,
  elements: [
    {
      wrapper: FitRelativeWrapper,
      name: '__transparent__',
      ref: containerRef,
      elements: [
        wrapTooltip(
          {
            wrapper: FlexCenterJustifyCenterWrapper,
            name: 'Wrapper',
            tooltip: { content: 'Change category', direction: 'top' },
            elements: [
              {
                component: SelectorButton,
                name: 'Selector',
                bindings: ({ isOpen }) => ({ isOpen, containerRef }),
                displayValue: ({ categories, selectedParentId }) => {
                  let category = categories.find(c => c.id === selectedParentId);
                  return category?.name ?? 'Category'
                }
              },
              {
                component: wrap(ClickableIcon, Ml2),
                name: 'ChevronIcon',
                bindings: ({ isOpen }) => ({ isOpen, containerRef }),
                displayValue: ({ isOpen }) => {
                  if (isOpen) {
                    return ChevronUpSvg({ applyThemeColor: true, width: 20, height: 20 })
                  }
                  return ChevronDownSvg({ applyThemeColor: true, width: 20, height: 20 })
                }
              },
            ]
          },
        ),
        {
          wrapper: DropdownBodyWrapper,
          name: 'Body',
          renderIf: ({ isOpen }) => isOpen,
          elements: [
            {
              component: DropdownSearchInput,
              name: 'Search',
              bindings: ({ searchTerm }) => ({ value: searchTerm, placeholder: "Search", withSearchIcon: true }),
            },
            {
              component: CategoryDropdown,
              name: 'Category',
              isListOf: {
                category: ({ categories, searchTerm }) => {
                  return filterCategories(categories, searchTerm);                   
                }
              },
              bindings: ({ categories, searchTerm, category, selectedCategoryId, selectedParentId }) => {
                const isOpen = !!searchTerm && filterCategories(categories, searchTerm)?.length > 0;
                return ({ isOpen, searchTerm, category, selectedCategoryId, selectedParentId })
              }
            }
          ]
        }
      ]
    }
  ]
};

export default ContainerComponent(definition);